import { render, staticRenderFns } from "./OpenResponse.vue?vue&type=template&id=20fc2935&scoped=true&"
import script from "./OpenResponse.vue?vue&type=script&lang=js&"
export * from "./OpenResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc2935",
  null
  
)

export default component.exports